/* NDC · Rediseño 2026-09 · Fase 1 · vanilla JS (defer).
   Módulos: toast, quick add "+", toggle grid/lista, drawer de filtros, contador móvil del botón "Ver n vinos",
   texto plegado, eventos GA4 (dataLayer). Convive con jQuery/Flex sin usarlos; el hot-reload de filtros lo hace
   <list-hot-reload> de Flex, que emite 'list:hot-reload:updated' tras re-renderizar. */
(function () {
  'use strict';
  var I18N = window.NDC_I18N || {};
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var mqDesktop = window.matchMedia('(min-width: 799px)');
  var isDesktop = function () { return mqDesktop.matches; };
  var track = function (payload) { try { (window.dataLayer = window.dataLayer || []).push(payload); } catch (e) {} };

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  function toast(msg, opts) {
    opts = opts || {};
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ndc-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('is-error', !!opts.error);
    toastEl.textContent = '';
    var span = document.createElement('span');
    span.textContent = msg;
    toastEl.appendChild(span);
    if (opts.linkHref) {
      var a = document.createElement('a');
      a.href = opts.linkHref;
      a.textContent = opts.linkText || '';
      toastEl.appendChild(a);
    }
    clearTimeout(toastTimer);
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, opts.duration || 3000);
  }

  /* ---------- Quick add "+" (form[data-ndc-quick-add]) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-ndc-quick-add]');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    var btn = form.querySelector('[data-ndc-plus]');
    if (!btn || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    var fd = new FormData(form);
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, body: j }; });
    }).then(function (res) {
      btn.classList.remove('is-loading');
      if (!res.ok) {
        toast((res.body && (res.body.description || res.body.message)) || I18N.error || 'Error', { error: true, duration: 4000 });
        return;
      }
      btn.classList.add('is-added');
      setTimeout(function () { btn.classList.remove('is-added'); }, 1200);
      toast(I18N.added || 'Añadido al carrito', { linkHref: root + 'cart', linkText: I18N.view_cart || 'Ver carrito' });
      // Flex: refresca el mini carrito y el contador [data-bind="itemCount"]
      try {
        if (window.PXUTheme && window.PXUTheme.jsAjaxCart && typeof window.PXUTheme.jsAjaxCart.updateView === 'function') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
      } catch (err) {}
      var item = res.body || {};
      var card = form.closest('[data-ndc-card]');
      track({
        event: 'quick_add',
        item_id: item.sku || item.variant_id,
        item_name: item.product_title,
        price: (item.price || 0) / 100,
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'PEN',
        context: card ? card.getAttribute('data-ndc-context') : 'collection'
      });
    }).catch(function () {
      btn.classList.remove('is-loading');
      toast(I18N.error || 'Error', { error: true });
    });
  }, true);

  /* ---------- Colección: toggle, drawer, contador móvil, GA4 ---------- */
  var coll = document.querySelector('[data-ndc-collection]');
  if (coll) {
    var KEY = 'ndc_feed_view';
    var lastOpener = null;

    function applyView(view, persist) {
      if (view !== 'list') view = 'grid';
      coll.setAttribute('data-ndc-view', view);
      coll.querySelectorAll('[data-ndc-view-btn]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-ndc-view-btn') === view));
      });
      if (!persist) return;
      try { localStorage.setItem(KEY, view); } catch (e) {}
      // atributo de carrito para que la siguiente carga server-side coincida (cart.attributes.ndc_feed_view)
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { ndc_feed_view: view } })
      }).catch(function () {});
      track({ event: 'list_grid_toggle', view: view });
    }
    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    if (saved && saved !== coll.getAttribute('data-ndc-view')) applyView(saved, false);

    // chip activo visible en la fila con scroll
    var activeChip = coll.querySelector('.ndc-chip.is-active');
    if (activeChip && activeChip.scrollIntoView && !isDesktop()) {
      try { activeChip.scrollIntoView({ block: 'nearest', inline: 'center' }); } catch (e) {}
    }

    /* Drawer */
    function drawer() { return coll.querySelector('[data-ndc-drawer]'); }
    function focusables(el) {
      return Array.prototype.slice.call(el.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), select, textarea, summary, [tabindex]:not([tabindex="-1"])'))
        .filter(function (n) { return n.offsetParent !== null || n === document.activeElement; });
    }
    function openDrawer(opener) {
      var d = drawer();
      if (!d || isDesktop()) return;
      lastOpener = opener || null;
      d.setAttribute('data-open', 'true');
      d.setAttribute('role', 'dialog');
      d.setAttribute('aria-modal', 'true');
      document.body.classList.add('ndc-drawer-open');
      coll.querySelectorAll('[data-ndc-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var title = d.querySelector('#ndc-filter-title');
      if (title) { try { title.focus({ preventScroll: true }); } catch (e) { title.focus(); } }
    }
    function closeDrawer(restoreFocus) {
      var d = drawer();
      document.body.classList.remove('ndc-drawer-open');
      if (d) {
        d.setAttribute('data-open', 'false');
        d.removeAttribute('role');
        d.removeAttribute('aria-modal');
      }
      coll.querySelectorAll('[data-ndc-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (restoreFocus !== false) {
        var target = (lastOpener && document.contains(lastOpener)) ? lastOpener : coll.querySelector('[data-ndc-drawer-open]');
        if (target) { try { target.focus({ preventScroll: true }); } catch (e) {} }
      }
    }
    function drawerIsOpen() { var d = drawer(); return !!d && d.getAttribute('data-open') === 'true'; }

    coll.addEventListener('click', function (e) {
      var t = e.target;
      var b = t.closest('[data-ndc-view-btn]');
      if (b) { applyView(b.getAttribute('data-ndc-view-btn'), true); return; }
      var o = t.closest('[data-ndc-drawer-open]');
      if (o) { e.preventDefault(); openDrawer(o); return; }
      if (t.closest('[data-ndc-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }
      var d = drawer();
      if (d && drawerIsOpen() && t === d) { closeDrawer(); return; } // clic en el fondo oscuro
      var fold = t.closest('[data-ndc-fold-toggle]');
      if (fold) {
        var box = fold.closest('[data-ndc-fold]');
        var open = !box.classList.contains('is-open');
        box.classList.toggle('is-open', open);
        fold.setAttribute('aria-expanded', String(open));
        fold.textContent = open ? fold.getAttribute('data-less') : fold.getAttribute('data-more');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!drawerIsOpen() || isDesktop()) return;
      if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var panel = drawer().querySelector('[data-ndc-drawer-panel]');
      var list = focusables(panel);
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* Móvil: los cambios dentro del drawer NO recargan el grid (eso lo hace el botón "Ver n vinos");
       solo actualizamos el contador del botón pidiendo la sección con los params actuales. */
    var countTimer = null, countAbort = null;
    function updateApplyCount(form) {
      var hr = coll.querySelector('list-hot-reload');
      var sectionId = hr && hr.getAttribute('section-id');
      var btn = form.querySelector('[data-ndc-apply]');
      if (!sectionId || !btn) return;
      var params = new URLSearchParams(new FormData(form));
      params.set('sections', sectionId);
      var url = (hr.getAttribute('context-url') || form.getAttribute('action')) + '?' + params.toString();
      if (countAbort) countAbort.abort();
      countAbort = new AbortController();
      fetch(url, { signal: countAbort.signal }).then(function (r) { return r.json(); }).then(function (j) {
        var html = j[sectionId];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var feed = doc.querySelector('[data-ndc-results]');
        if (!feed) return;
        var n = feed.getAttribute('data-ndc-results');
        var tpl = btn.getAttribute('data-ndc-apply-template') || '%n';
        btn.textContent = tpl.replace('%n', n);
      }).catch(function () {});
    }
    function interceptMobileChange(e) {
      if (isDesktop()) return;
      /* Las facetas locales (Uva/Zona) no viajan al servidor: las gestiona applyLocalFacets. */
      if (e.target.matches && e.target.matches('[data-ndc-local-input]')) return;
      var form = e.target.closest && e.target.closest('[data-ndc-filter-form]');
      if (!form) return;
      e.stopPropagation(); // que list-hot-reload no re-renderice con el drawer abierto
      clearTimeout(countTimer);
      countTimer = setTimeout(function () { updateApplyCount(form); }, 400);
    }
    document.addEventListener('change', interceptMobileChange, true);
    document.addEventListener('list:price-range:slider-change', interceptMobileChange, true);

    /* Inputs de precio vacíos: sin name, para que no viajen como filter.v.price.gte= en la URL */
    function syncPriceNames() {
      coll.querySelectorAll('[data-ndc-price-range] input').forEach(function (inp) {
        if (!inp.hasAttribute('data-name')) inp.setAttribute('data-name', inp.getAttribute('name') || '');
        if (inp.value === '') inp.removeAttribute('name'); else inp.setAttribute('name', inp.getAttribute('data-name'));
      });
    }
    syncPriceNames();
    document.addEventListener('input', function (e) { if (e.target.closest && e.target.closest('[data-ndc-price-range]')) syncPriceNames(); }, true);

    /* ---------- Facetas locales de Uva y Zona ----------
       La tienda aún no tiene Search & Discovery, así que Shopify no ofrece facetas por metafield.
       Estas dos filtran en el navegador sobre las cards ya pintadas: leen data-ndc-cepa y data-ndc-zona
       del snippet ndc-product-card. Se combinan con los filtros de Shopify (precio), que siguen
       viajando por URL. Cuando se instale Search & Discovery, el snippet ndc-local-facets deja de
       pintarlas y este bloque no encuentra nada que hacer. */
    var localMemory = { cepa: [], zona: [] };
    function localInputs() { return Array.prototype.slice.call(coll.querySelectorAll('[data-ndc-local-input]')); }
    function restoreLocalSelection() {
      localInputs().forEach(function (i) {
        var kind = i.getAttribute('data-ndc-local-input');
        i.checked = localMemory[kind].indexOf(i.value) !== -1;
      });
    }
    function localSelection() {
      var sel = { cepa: [], zona: [] };
      localInputs().forEach(function (i) { if (i.checked) sel[i.getAttribute('data-ndc-local-input')].push(i.value); });
      return sel;
    }
    function cardMatches(card, sel) {
      if (sel.cepa.length) {
        var cs = (card.getAttribute('data-ndc-cepa') || '').split('|');
        if (!sel.cepa.some(function (v) { return cs.indexOf(v) !== -1; })) return false;
      }
      if (sel.zona.length) {
        var z = card.getAttribute('data-ndc-zona') || '';
        if (sel.zona.indexOf(z) === -1) return false;
      }
      return true;
    }
    function applyLocalFacets(silent) {
      var grid = coll.querySelector('[data-ndc-grid]');
      if (!grid || !localInputs().length) return;
      var sel = localSelection();
      localMemory = sel;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-ndc-card]'));
      var shown = 0;
      cards.forEach(function (card) {
        var ok = cardMatches(card, sel);
        card.hidden = !ok;
        if (ok) shown++;
      });
      var active = sel.cepa.length + sel.zona.length;
      coll.setAttribute('data-ndc-local-active', active ? 'true' : 'false');

      /* Contador de la barra y del botón "Ver n vinos" */
      var feed = coll.querySelector('[data-ndc-results]');
      var total = feed ? Number(feed.getAttribute('data-ndc-results')) : cards.length;
      var noun = total === 1 ? 'vino' : 'vinos';
      var countEl = coll.querySelector('[data-ndc-count]');
      if (countEl) {
        if (!countEl.hasAttribute('data-ndc-count-base')) countEl.setAttribute('data-ndc-count-base', countEl.textContent);
        countEl.textContent = active ? (shown + ' de ' + total + ' ' + noun) : countEl.getAttribute('data-ndc-count-base');
      }
      var applyBtn = coll.querySelector('[data-ndc-apply]');
      if (applyBtn && active) {
        var tpl = applyBtn.getAttribute('data-ndc-apply-template') || '%n';
        var txt = tpl.replace('%n', shown);
        if (shown === 1) txt = txt.replace('vinos', 'vino');
        applyBtn.textContent = txt;
      }

      /* Badge por faceta y estado vacío */
      coll.querySelectorAll('[data-ndc-local-facet]').forEach(function (fac) {
        var kind = fac.getAttribute('data-ndc-local-facet');
        var badge = fac.querySelector('[data-ndc-local-active]');
        if (!badge) return;
        var n = sel[kind].length;
        badge.textContent = n ? ' (' + n + ')' : '';
        badge.hidden = !n;
      });
      var empty = coll.querySelector('[data-ndc-local-empty]');
      if (empty) empty.hidden = !(active && shown === 0);

      renderLocalChips(sel);
      if (!silent && active) {
        track({ event: 'filter_apply', filters: sel.cepa.map(function (v) { return 'cepa=' + v; }).concat(sel.zona.map(function (v) { return 'zona=' + v; })), results: shown, collection: coll.getAttribute('data-ndc-collection-handle') });
      }
    }
    function renderLocalChips(sel) {
      var host = coll.querySelector('[data-ndc-local-chips]');
      if (!host) return;
      host.textContent = '';
      var all = sel.cepa.map(function (v) { return ['cepa', v]; }).concat(sel.zona.map(function (v) { return ['zona', v]; }));
      all.forEach(function (pair) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ndc-chip ndc-chip--filter';
        b.setAttribute('data-ndc-local-remove', pair[0]);
        b.value = pair[1];
        b.textContent = pair[1];
        b.setAttribute('aria-label', 'Quitar ' + pair[1]);
        li.appendChild(b);
        host.appendChild(li);
      });
      host.hidden = all.length === 0;
    }
    coll.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('[data-ndc-local-input]')) return;
      e.stopPropagation(); // no dispares el hot-reload de Flex: aquí no hay nada que pedir al servidor
      applyLocalFacets(false);
    }, true);
    coll.addEventListener('click', function (e) {
      var rm = e.target.closest && e.target.closest('[data-ndc-local-remove]');
      if (rm) {
        e.preventDefault();
        localInputs().forEach(function (i) {
          if (i.getAttribute('data-ndc-local-input') === rm.getAttribute('data-ndc-local-remove') && i.value === rm.value) i.checked = false;
        });
        applyLocalFacets(true);
        return;
      }
      if (e.target.closest && e.target.closest('[data-ndc-local-clear]')) {
        e.preventDefault();
        localInputs().forEach(function (i) { i.checked = false; });
        applyLocalFacets(true);
      }
    });
    applyLocalFacets(true);

    /* Tras cada recarga AJAX de Flex: re-aplicar vista, cerrar drawer (se re-renderiza cerrado), GA4 */
    document.addEventListener('list:hot-reload:updated', function () {
      applyView(coll.getAttribute('data-ndc-view'), false);
      syncPriceNames();
      restoreLocalSelection();
      applyLocalFacets(true);
      var wasOpen = document.body.classList.contains('ndc-drawer-open');
      closeDrawer(wasOpen);
      initFolds();
      if (window.location.search.indexOf('filter.') !== -1) {
        var feed = coll.querySelector('[data-ndc-results]');
        var filters = [];
        new URLSearchParams(window.location.search).forEach(function (v, k) { if (k.indexOf('filter.') === 0 && v !== '') filters.push(k + '=' + v); });
        track({ event: 'filter_apply', filters: filters, results: feed ? Number(feed.getAttribute('data-ndc-results')) : undefined, collection: coll.getAttribute('data-ndc-collection-handle') });
      }
    });

    mqDesktop.addEventListener ? mqDesktop.addEventListener('change', function () { if (isDesktop()) closeDrawer(false); })
                               : mqDesktop.addListener(function () { if (isDesktop()) closeDrawer(false); });
  }

  /* ---------- Texto plegado: solo mostrar "Leer más" si hay algo que plegar ---------- */
  function initFolds() {
    document.querySelectorAll('[data-ndc-fold]').forEach(function (box) {
      var body = box.querySelector('[data-ndc-fold-body]');
      if (!body) return;
      var needs = body.scrollHeight > body.clientHeight + 8;
      box.classList.toggle('has-toggle', needs || box.classList.contains('is-open'));
    });
  }
  initFolds();
  window.addEventListener('load', initFolds);
  document.addEventListener('click', function (e) {
    var fold = e.target.closest && e.target.closest('[data-ndc-fold-toggle]');
    if (!fold || fold.closest('[data-ndc-collection]')) return; // dentro de la colección ya lo maneja coll
    var box = fold.closest('[data-ndc-fold]');
    var open = !box.classList.contains('is-open');
    box.classList.toggle('is-open', open);
    fold.setAttribute('aria-expanded', String(open));
    fold.textContent = open ? fold.getAttribute('data-less') : fold.getAttribute('data-more');
  });
})();
